import { render, staticRenderFns } from "./PsinAddMain.vue?vue&type=template&id=4cc2a385&scoped=true&"
import script from "./PsinAddMain.vue?vue&type=script&lang=js&"
export * from "./PsinAddMain.vue?vue&type=script&lang=js&"
import style0 from "./PsinAddMain.vue?vue&type=style&index=0&id=4cc2a385&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc2a385",
  null
  
)

export default component.exports